import type { IQuery } from "@citrine/client";
import ClientBase from "@citrine/client";
import type { MajorStatus } from "@citrine/types/status";

import type { PredictorSortOption } from "../predictor/predictor-client";

import type { PredictorSummary } from "./predictor-summary";

interface PredictorSummaryQuery extends IQuery {
  page?: number;
  per_page?: number;
  name?: string;
  archived?: boolean;
  data_source?: string;
  has_erds?: boolean;
  for_branch?: string;
  sort_by?: PredictorSortOption | `${PredictorSortOption}.asc`;
  status?: MajorStatus;
}

export class PredictorSummaryClient extends ClientBase<
  PredictorSummary,
  string,
  PredictorSummaryQuery
> {
  create: never;
  useCreate: never;
  delete: never;
  useDelete: never;
  patch: never;
  usePatch: never;
  update: never;
  useUpdate: never;

  protected constructor(protected readonly projectId: string) {
    super({
      endpoint: `/api/v4/projects/${projectId}/predictor-summaries`,
      findField: "response",
      defaultQuery: {
        page: 1,
        per_page: 20,
        name: undefined,
        archived: undefined,
        sort_by: undefined,
        data_source: undefined,
        has_erds: undefined,
        for_branch: undefined,
        status: undefined,
      },
    });
  }

  static getInstance(projectId: string) {
    return new PredictorSummaryClient(projectId);
  }

  protected getConfig(id?: string) {
    return {
      method: "GET",
      url: `/api/v3/projects/${this.projectId}/predictor-summaries/${id}`,
    };
  }
}
